import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipProblemaComponent } from './tip-problema.component';
import { AddTipProblemaComponent } from './add-tip-problema/add-tip-problema.component';
import { EditTipProblemaComponent } from './edit-tip-problema/edit-tip-problema.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        TipProblemaComponent,
        AddTipProblemaComponent,
        EditTipProblemaComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [TipProblemaComponent]
})
export class TipProblemaModule { }
